/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ShareStoryToRoMutationVariables = Types.Exact<{
  input: Types.InputMaybe<Types.GlobalInboxItemCreate>;
}>;


export type ShareStoryToRoMutation = { __typename: 'Mutation', createGlobalInboxItem: { __typename: 'Feed', id: string } | null };


export const ShareStoryToRoDocument = gql`
    mutation shareStoryToRO($input: GlobalInboxItemCreate) {
  createGlobalInboxItem(input: $input) {
    id
  }
}
    `;
export type ShareStoryToRoMutationFn = Apollo.MutationFunction<ShareStoryToRoMutation, ShareStoryToRoMutationVariables>;

/**
 * __useShareStoryToRoMutation__
 *
 * To run a mutation, you first call `useShareStoryToRoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareStoryToRoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareStoryToRoMutation, { data, loading, error }] = useShareStoryToRoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareStoryToRoMutation(baseOptions?: Apollo.MutationHookOptions<ShareStoryToRoMutation, ShareStoryToRoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareStoryToRoMutation, ShareStoryToRoMutationVariables>(ShareStoryToRoDocument, options);
      }
export type ShareStoryToRoMutationHookResult = ReturnType<typeof useShareStoryToRoMutation>;
export type ShareStoryToRoMutationOptions = Apollo.BaseMutationOptions<ShareStoryToRoMutation, ShareStoryToRoMutationVariables>;